import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';

import { AuthContext } from '../../../../../context';

import style from './index.module.scss';

const MenuItem = ({ currentUser, itemName }) => (
  <DropdownItem>
    <Link
      to={{
        pathname: `/account/${currentUser.fullname}/${
          itemName ? itemName.toLowerCase() : ''
        }`,
        state: {
          userId: currentUser.id,
        },
      }}
    >
      {itemName ? itemName : 'Profile'}
    </Link>
  </DropdownItem>
);

class UserLinks extends Component {
  static contextType = AuthContext;

  state = {
    isOpen: false,
  };

  toggleDropdown = () =>
    this.setState(prevState => ({
      isOpen: !prevState.isOpen,
    }));

  handleLogout = handleAuthentication => {
    const itemsToRemove = ['quora-token', 'current-user'];

    itemsToRemove.forEach(item => localStorage.removeItem(item));

    handleAuthentication(false, null);

    this.props.history.push('/');
  }

  render() {
    const { isOpen } = this.state;
    const { currentUser, handleAuthentication } = this.context;

    return (
      <Dropdown isOpen={isOpen} toggle={this.toggleDropdown}>
        
        <DropdownToggle tag="div">
          <div>
            <img 
              className={style.img} 
              src={currentUser.imgUrl || 'https://i.imgur.com/qHpJwKV.jpg'}
              alt={currentUser.fullname}
              data-toggle="dropdown" 
              aria-haspopup="true" 
              aria-expanded={isOpen}
            />
          </div>
        </DropdownToggle>
        <DropdownMenu>
          <MenuItem currentUser={currentUser} itemName="" />
          <MenuItem currentUser={currentUser} itemName="Blogs" />
          <MenuItem currentUser={currentUser} itemName="Stats" />
          <MenuItem currentUser={currentUser} itemName="Settings" />
          <DropdownItem divider />
          <DropdownItem>
            <span 
              style={{fontSize: '0.85rem'}} 
              onClick={() => this.handleLogout(handleAuthentication)}
            >
              Logout
            </span>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    );
  }
}

export default withRouter(UserLinks);
